export default __webpack_public_path__ + "static/media/topic1.cbfccaf1.png";